import { price as priceUtils } from '@eti/utils';
import { formValueSelector } from 'redux-form';
export const getNoneSelected = (form, name) => state => {
  var _formData$value;
  const formData = formValueSelector(form)(state, name);
  const value = formData === null || formData === void 0 || (_formData$value = formData.value) === null || _formData$value === void 0 ? void 0 : _formData$value.value;
  return value === 'false';
};
export const getSmallMealPrice = (form, name) => state => {
  var _formData$value$price, _formData$value2;
  const formData = formValueSelector(form)(state, name);
  return (_formData$value$price = formData === null || formData === void 0 || (_formData$value2 = formData.value) === null || _formData$value2 === void 0 ? void 0 : _formData$value2.priceRaw) !== null && _formData$value$price !== void 0 ? _formData$value$price : null;
};
export const getTravelers = (name, form) => state => {
  var _formData$travelers;
  const formData = formValueSelector(form)(state, name);
  return (_formData$travelers = formData === null || formData === void 0 ? void 0 : formData.travelers) !== null && _formData$travelers !== void 0 ? _formData$travelers : null;
};
export const sortTravelers = travelers => {
  const canSortTravelers = travelers.some(traveler => traveler.travelerId || traveler.travelerType);
  if (canSortTravelers) {
    return travelers.sort((traveler1, traveler2) => {
      var _traveler1$travelerTy;
      return traveler2.travelerType && ((_traveler1$travelerTy = traveler1.travelerType) === null || _traveler1$travelerTy === void 0 ? void 0 : _traveler1$travelerTy.localeCompare(traveler2.travelerType)) || Number(traveler1 === null || traveler1 === void 0 ? void 0 : traveler1.travelerId) - Number(traveler2 === null || traveler2 === void 0 ? void 0 : traveler2.travelerId);
    });
  }
  return travelers;
};
export const getTravelerField = (id, name) => name && id ? `${name}.travelers.traveler-${id}` : null;
export const getTravelerChoice = (name, form, id) => state => {
  var _getTravelerField, _formData$choice;
  const travelerField = (_getTravelerField = getTravelerField(id, name)) !== null && _getTravelerField !== void 0 ? _getTravelerField : '';
  const formData = formValueSelector(form)(state, travelerField);
  return (_formData$choice = formData === null || formData === void 0 ? void 0 : formData.choice) !== null && _formData$choice !== void 0 ? _formData$choice : {};
};
export const getSelectedTraveler = (name, form, id) => state => {
  var _getTravelerField2, _formData$selected;
  const travelerField = (_getTravelerField2 = getTravelerField(id, name)) !== null && _getTravelerField2 !== void 0 ? _getTravelerField2 : '';
  const formData = formValueSelector(form)(state, travelerField);
  return (_formData$selected = formData === null || formData === void 0 ? void 0 : formData.selected) !== null && _formData$selected !== void 0 ? _formData$selected : null;
};
export const hasAnyTravelerSelected = (name, form) => state => {
  var _formData$travelers2;
  const formData = formValueSelector(form)(state, name);
  const travelers = Object.values((_formData$travelers2 = formData === null || formData === void 0 ? void 0 : formData.travelers) !== null && _formData$travelers2 !== void 0 ? _formData$travelers2 : {});
  return travelers.some(_ref => {
    let {
      selected
    } = _ref;
    return selected;
  });
};
export const getTravelersWithChoice = (name, form) => state => {
  var _formData$travelers3;
  const formData = formValueSelector(form)(state, name);
  const travelers = Object.values((_formData$travelers3 = formData === null || formData === void 0 ? void 0 : formData.travelers) !== null && _formData$travelers3 !== void 0 ? _formData$travelers3 : {});
  return travelers.filter(traveler => {
    var _traveler$choice$valu, _traveler$choice, _traveler$choice$pric, _traveler$choice2;
    const choiceValue = (_traveler$choice$valu = traveler === null || traveler === void 0 || (_traveler$choice = traveler.choice) === null || _traveler$choice === void 0 ? void 0 : _traveler$choice.value) !== null && _traveler$choice$valu !== void 0 ? _traveler$choice$valu : false;
    const choicePrice = (_traveler$choice$pric = traveler === null || traveler === void 0 || (_traveler$choice2 = traveler.choice) === null || _traveler$choice2 === void 0 ? void 0 : _traveler$choice2.priceRaw) !== null && _traveler$choice$pric !== void 0 ? _traveler$choice$pric : 0;
    return choiceValue && choicePrice > 0;
  }).map(traveler => {
    var _traveler$choice3;
    return traveler === null || traveler === void 0 || (_traveler$choice3 = traveler.choice) === null || _traveler$choice3 === void 0 ? void 0 : _traveler$choice3.travelerId;
  });
};
export const getMealPreselectedTravelerChoices = (travelers, sellSpecification) => {
  const travelerIds = travelers.map(traveler => traveler.id);
  const choice = sellSpecification === null || sellSpecification === void 0 ? void 0 : sellSpecification.availableChoices[0];
  if (!choice) {
    return {};
  }
  const {
    pricePerTravelers
  } = sellSpecification;
  return travelerIds.reduce((acc, id) => {
    var _travelerPrice$price$, _travelerPrice$price, _travelerPrice$price$2, _travelerPrice$price2;
    const travelerPrice = pricePerTravelers.find(pricePerTraveler => pricePerTraveler && pricePerTraveler.travelerId === id);
    return {
      ...acc,
      [`traveler-${id}`]: {
        choice: {
          choiceId: choice.id,
          label: choice.name,
          price: priceUtils.formatPrice((_travelerPrice$price$ = travelerPrice === null || travelerPrice === void 0 || (_travelerPrice$price = travelerPrice.price) === null || _travelerPrice$price === void 0 || (_travelerPrice$price = _travelerPrice$price.price) === null || _travelerPrice$price === void 0 ? void 0 : _travelerPrice$price.value) !== null && _travelerPrice$price$ !== void 0 ? _travelerPrice$price$ : 0),
          priceRaw: (_travelerPrice$price$2 = travelerPrice === null || travelerPrice === void 0 || (_travelerPrice$price2 = travelerPrice.price) === null || _travelerPrice$price2 === void 0 || (_travelerPrice$price2 = _travelerPrice$price2.price) === null || _travelerPrice$price2 === void 0 ? void 0 : _travelerPrice$price2.value) !== null && _travelerPrice$price$2 !== void 0 ? _travelerPrice$price$2 : 0,
          travelerId: id,
          value: choice.id
        }
      }
    };
  }, {});
};
//# sourceMappingURL=smallMealUtil.js.map